// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../../../../environments/environment";
import {SimUserExtendedService} from "@services";

export interface DialogData_UserLoginDialogComponentOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-user-login-dialog",
	templateUrl: "./user-login-dialog.component.html",
	styleUrl: "./user-login-dialog.component.scss",
	standalone: false,
})
export class UserLoginDialogComponent extends BasicMaterialDialog<
	UserLoginDialogComponent,
	MatDialogDataBaseInput,
	DialogData_UserLoginDialogComponentOutput
> {
	loginFormGroup = new FormGroup({
		username: new FormControl("", Validators.required),
		password: new FormControl("", Validators.required),
	});

	hidePassword: boolean;
	loggingIn: boolean;

	constructor(
		private _injector: Injector,
		private _translate: TranslateService,
		private _simUserService: SimUserExtendedService,
	) {
		super(_injector);
	}

	login() {
		this.loggingIn = true;
		this._simUserService
			.login({
				usernameOrEmail: this.loginFormGroup.controls.username.value,
				password: this.loginFormGroup.controls.password.value,
				loginUrl: null,
				checkOnly: false,
			})
			.then(
				(_) => {
					this._simUserService.reload().then(() => {
						this.close({action: "ok"});
					});
				},
				(error) => {
					let reason = "Please try again later!";
					if ([401, 503].includes(error.status)) {
						reason = this._translate.instant(error.error);
					}

					this.loginFormGroup.controls.username.setErrors({
						serverError: reason,
					});
					this.loginFormGroup.controls.password.setErrors({
						serverError: reason,
					});
				},
			)
			.finally(() => {
				this.loggingIn = false;
			});
	}

	getUsernameErrorMessage() {
		return this.loginFormGroup.controls.username.hasError("required")
			? this._translate.instant(this.T.LOGIN_PAGE_USERNAME_ERROR_MESSAGE)
			: this.loginFormGroup.controls.username.hasError("serverError")
				? this.loginFormGroup.controls.username.getError("serverError")
				: "";
	}

	getPasswordErrorMessage() {
		return this.loginFormGroup.controls.password.hasError("required")
			? this._translate.instant(this.T.LOGIN_PAGE_USERNAME_ERROR_MESSAGE)
			: this.loginFormGroup.controls.password.hasError("serverError")
				? this.loginFormGroup.controls.password.getError("serverError")
				: "";
	}
}
